import { useState, useEffect } from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// ----------------------------------------------------------------------

const PROGRESS_MESSAGES = [
  'Analyzing your content...',
  'Understanding the educational concepts...',
  'Designing interactive elements...',
  'Building the simulation structure...',
  'Adding visual components...',
  'Implementing interactivity...',
  'Optimizing for learning...',
  'Polishing the experience...',
  'Almost there...',
  'Finalizing simulation...',
];

const MESSAGE_INTERVAL = 3000; // Change message every 3 seconds

export function TypingIndicator() {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % PROGRESS_MESSAGES.length);
    }, MESSAGE_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ px: 3, pb: 2 }}>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          transition: 'opacity 0.3s ease-in-out',
        }}
      >
        {PROGRESS_MESSAGES[messageIndex]}
      </Typography>
    </Stack>
  );
}
